import classNames from 'classnames';
import React, { useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { BsChevronDown } from 'react-icons/bs';
import { createUseStyles } from 'react-jss';
import { useShake } from '../../hooks/use-shake';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';

const animateFromDown = 'animate__animated animate__fadeInUp animate__delay-1s';

function EmptyButtons({ onAssignClick, onNewClick }) {
  const { showingModal } = useStorage();
  const { t } = useTranslation();
  const buttonRef = useRef();
  const classes = useStyles();

  useShake({
    element: buttonRef?.current,
    enabled: !showingModal,
    interval: layoutDefaults.shakeInterval * 2,
  });

  const onMoreClick = () => {
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 1000000);
  };

  return (
    <div
      className={classNames(classes.container, animateFromDown)}
      style={{ '--animate-delay': '2.5s' }}
    >
      <Button
        ref={buttonRef}
        size="md"
        onClick={onAssignClick}
        variant="primary"
      >
        {t('empty-button.link-my-menu_1')}
        <b>{t('empty-button.link-my-menu_2')}</b>
        {t('empty-button.link-my-menu_3')}
      </Button>

      <Button size="md" onClick={onNewClick} variant="secondary">
        {t('empty-button.create-new_1')}
        <b>{t('empty-button.create-new_2')}</b>
        {t('empty-button.create-new_3')}
      </Button>

      <div
        className={classNames(classes.more, animateFromDown)}
        style={{ '--animate-delay': '4.4s' }}
        onClick={onMoreClick}
        aria-hidden="true"
      >
        {t('empty-button.know-more')}
        <BsChevronDown />
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',

    justifyContent: 'center',
    alignItems: 'center',

    marginTop: layoutDefaults.biggestVerticalMargin * 2,
    marginLeft: layoutDefaults.biggerHorizontalMargin,
    marginRight: layoutDefaults.biggerHorizontalMargin,

    // border: '1px solid red',
  },
  more: {
    // alignSelf: 'center',
    cursor: 'pointer',
    color: layoutDefaults.textPlaceholderColor,
    textAlign: 'center',
    fontSize: layoutDefaults.smallFontSize,
    // opacity: 0.1,

    marginTop: layoutDefaults.biggerVerticalMargin,
    marginBottom: layoutDefaults.bigVerticalMargin,

    // border: '1px solid red',
  },
});

export { EmptyButtons };
